<template>
  <b-card>
    <validation-observer ref="form">
      <b-form @submit.prevent="handleSubmit">
        <b-row>
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descricao"
              rules="required"
            >
              <b-form-group label="Descrição" label-for="descricao">
                <b-form-input
                  id="descricao"
                  v-model="eventDiscount.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Digite a descrição do desconto"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="evento"
              rules="required"
            >
              <b-form-group label="Evento" label-for="evento">
                <v-select
                  id="evento"
                  v-model="eventDiscount.evento"
                  :options="eventosCombo"
                  label="descricao"
                  :reduce="(evento) => evento"
                  placeholder="Selecione o evento"
                >
                  <template #no-options>
                    <div class="text-muted">Nenhum evento encontrado</div>
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="tipo"
              rules="required"
            >
              <b-form-group label="Tipo" label-for="tipo">
                <v-select
                  id="tipo"
                  v-model="eventDiscount.tipo"
                  :options="tiposCombo"
                  label="nome"
                  :reduce="(tipo) => tipo"
                  placeholder="Selecione o tipo"
                >
                  <template #no-options>
                    <div class="text-muted">Nenhum tipo encontrado</div>
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="tipoRegistro"
              rules="required"
            >
              <b-form-group label="Tipo de Registro" label-for="tipoRegistro">
                <v-select
                  id="tipoRegistro"
                  v-model="eventDiscount.tipoRegistro"
                  :options="tiposRegistroCombo"
                  label="nome"
                  :reduce="(tipo) => tipo"
                  placeholder="Selecione o tipo de registro"
                >
                  <template #no-options>
                    <div class="text-muted">
                      Nenhum tipo de registro encontrado
                    </div>
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="3">
            <validation-provider
              #default="{ errors }"
              name="percentualDesconto"
              rules="required"
            >
              <b-form-group
                label="Percentual de Desconto"
                label-for="percentualDesconto"
              >
                <b-form-input
                  id="percentualDesconto"
                  v-model="eventDiscount.percentualDesconto"
                  type="number"
                  min="0"
                  max="100"
                  placeholder="0-100"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="3">
            <validation-provider
              #default="{ errors }"
              name="valorDesconto"
              rules="required"
            >
              <b-form-group label="Valor do Desconto" label-for="valorDesconto">
                <money
                  id="valorDesconto"
                  v-model="eventDiscount.valorDesconto"
                  v-bind="money"
                  class="form-control"
                  placeholder="0,00"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-checkbox
              id="ativo"
              v-model="eventDiscount.ativo"
              name="ativo"
              switch
            >
              {{ eventDiscount.ativo ? "Ativo" : "Inativo" }}
            </b-form-checkbox>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_ADMIM_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from "vuex";
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from "bootstrap-vue";
import { Money } from "v-money";
import mixinsGlobal from "@/mixins";
import vSelect from "vue-select";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import Ripple from "vue-ripple-directive";
import { verificarPermissao } from "@/auth/utils";

export default {
  name: "EventDiscountForm",
  components: {
    Money,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BFormCheckbox,
    vSelect,
    ButtonsFormVue,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      verificarPermissao,
      required,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
      // These should be loaded from your API
      eventosCombo: [],
      tiposCombo: [],
      tiposRegistroCombo: [],
      loading: false,
    };
  },
  computed: {
    ...mapState("eventDiscountSettingsModule", {
      eventDiscount: (state) => state.eventDiscount,
    }),
  },
  created() {
    this.loading = true;
    this.loadDependencies();
  },
  methods: {
    async loadDependencies() {
      try {
        // TODO: Replace with actual API calls
        this.eventosCombo = await this.$store.dispatch(
          "eventDiscountSettingsModule/getListEventDiscount"
        );
        this.tiposCombo = await this.$store.dispatch(
          "eventDiscountSettingsModule/getListTipo"
        );
        this.tiposRegistroCombo = await this.$store.dispatch(
          "eventDiscountSettingsModule/getListTipoRegistro"
        );
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error("Error loading dependencies:", error);
      }
    },
    save() {
      this.$refs.form.validate().then((success) => {
        console.log("success", success);
        if (success) {
          if (this.eventDiscount.id) {
            this.$store.dispatch(
              "eventDiscountSettingsModule/edit",
              this.eventDiscount
            );
          } else {
            this.$store.dispatch(
              "eventDiscountSettingsModule/insertNew",
              this.eventDiscount
            );
          }
        }
      });
    },
    cancel() {
      this.$emit("cancelar");
      this.cleanObjeto();
      this.$store.dispatch("eventDiscountSettingsModule/reset");
    },
    cleanObjeto() {
      this.$store.dispatch("eventDiscountSettingsModule/reset");
    },
  },
};
</script>
